import React from "react";
import { Link } from "react-router-dom";
import Crown from "@/components/Crown";

const CTABand = ({
  eyebrow = "The work begins here",
  title = "The woman you’ve been looking for is you.",
  sub = "Book a complimentary 15-minute visionary call. We’ll talk about where you are, what you’re carrying, and whether this is the right room for you.",
  primaryLabel = "Submit Your Application →",
  primaryTo = "/contact",
  secondaryLabel = "Read the Story",
  secondaryTo = "/about",
}) => (
  <section className="cta-band" data-testid="cta-band">
    <div className="cta-inner">
      <div style={{ display: "flex", justifyContent: "center" }}>
        <Crown size={44} color="#F3B21A" opacity={0.85} />
      </div>
      <div className="eyebrow gold" style={{ justifyContent: "center", marginTop: 16 }}>
        {eyebrow}
      </div>
      <h2 className="h-display">{title}</h2>
      <p className="cta-sub">{sub}</p>
      <div className="cta-buttons">
        <Link to={primaryTo} className="btn btn-primary" data-testid="cta-primary">
          {primaryLabel}
        </Link>
        {secondaryTo && (
          <Link to={secondaryTo} className="btn btn-ghost" data-testid="cta-secondary">
            {secondaryLabel}
          </Link>
        )}
      </div>
    </div>
  </section>
);

export default CTABand;
